import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";

import Logo from "../../components/Logo";
import NewPasswordChallengeCard from "../../components/NewPasswordChallengeCard";
import RequestPasswordCard from "../../components/RequestPasswordCard";
import ResetPasswordCard from "../../components/ResetPasswordCard";
import SignInCard from "../../components/SignInCard";

import useUserStore from "../../store/User.store";

import "./userFlow.scss";

const appInfo = {
  appVersion: process.env.REACT_APP_VERSION,
};

const UserFlow = ({ type }) => {
  const user = useUserStore((state) => state.data.user);
  const location = useLocation();

  if (user && type !== "new-password-challenge") {
    return <Navigate to="/proposals" state={{ from: location }} replace />;
  }

  const cards = {
    signin: <SignInCard />,
    "request-password": <RequestPasswordCard />,
    "reset-password": <ResetPasswordCard />,
    "new-password-challenge": <NewPasswordChallengeCard />,
  };

  return (
    <div className="page page--userFlow">
      <div className="page__wrapper">
        <header>
          <h1>
            <Logo />
            <div className="logotype">Customized SMA Platform Portal</div>
          </h1>
          <h3>{appInfo.appVersion}</h3>
        </header>
        <section className="page__section">{cards[type]}</section>
      </div>
    </div>
  );
};

UserFlow.propTypes = {
  type: PropTypes.oneOf([
    "signin",
    "request-password",
    "reset-password",
    "new-password-challenge",
  ]).isRequired,
};

export default UserFlow;
